import React from 'react';
// COMPONENTS
import ModalAddToList from 'components/ModalAddToList';
import CreateNewList from 'components/CreateNewList';
import ModalAddress from "components/ModalAddress"
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDeliverySelector from 'components/ModalDeliverySelector';
import ModalLogin from 'components/ModalLogin';
import ModalPassword from "components/ModalPassword";
import ModalRegister from 'components/ModalRegister';
import ModalFeedbackRegister from 'components/ModalFeedbackRegister';
import ModalError from 'components/ModalError';
import ModalProductInCart from 'components/ModalProductInCart';
import ModalValidationCode from "components/ModalValidationCode";
import ModalValidationCodeCheckout from "components/ModalValidationCodeCheckout";
import ProductPreview from 'components/ProductPreview';
import ModalPersistsAddress from "components/ModalPersistsAddress";
import ModalLostProducts from 'components/ModalLostProducts';
import ModalProductsCart from 'components/Checkout/ModalProductsCart';
import NotificationContent from 'components/NotificationContent';
import ModalUserInfo from 'components/ModalUserInfo';
import ModalReschedule from 'components/ModalReschedule';
import ModalConfirmReschedule from 'components/ModalConfirmReschedule';
import BannerHour from 'components/Header/BannerHour';
import ModalNewFeature from 'components/ModalNewFeature';
import ModalDateDelivery from 'components/ModalDateDelivery';
import ModalOrderCancelSuccess from 'components/ModalOrderCancelSuccess';
import ModalTermsConditions from 'components/ModalTermsConditions';
import ModalNewsletter from 'components/Footer/ModalNewsletter';
import ModalAddNotes from 'components/Cart/CartProducts/ModalAddNotes';
import MessageInfo from 'components/Header/MessageInfo';
import DrawerSimilarProducts from 'components/Drawers/DrawerSimilarProducts';
import DrawerMiniCart from 'components/Drawers/DrawerMiniCart';
import DrawerQuickPurchase from 'components/Drawers/DrawerQuickPurchase';
import DrawerAddBankAccount from 'components/Drawers/DrawerAddBankAccount';
import DrawerReviews from 'components/Drawers/DrawerReviews';
import DrawerWelcomePrime from 'components/Drawers/DrawerWelcomePrime';
import DrawerRegisterPrime from 'components/Drawers/DrawerRegisterPrime';
import DrawerPrimeInvitation from 'components/Drawers/DrawerPrimeInvitation';
import DrawerPaymentMethodPrime from 'components/Drawers/DrawerPaymentMethodPrime';
import ModalTrackingOrder from 'components/ModalTrackingOrder'
import DrawerClientUpdate from 'components/Drawers/DrawerClientUpdate';
import DrawerAddToList from 'components/Drawers/DrawerAddToList';
import DrawerScheduledList from 'components/Drawers/DrawerScheduledList';
import DrawerAddressSelection from 'components/Drawers/DrawerAddressSelection';
import ModalOrderSuspension from 'components/ModalOrderSuspension';
import DrawerPaymentMethod from 'components/Drawers/DrawerPaymentMethod';
import ModalPersistentCart from 'components/ModalPersistentCart';
import style from './style.scss';//NOSONAR

const GeneralContent = () => {
    return (
        <div className='general-content-page'>
            <ModalLogin />
            <ModalPassword />
            <ModalValidationCode />
            <ModalValidationCodeCheckout />
            <ModalRegister />
            <ModalFeedbackRegister />
            <ModalError />
            <ModalAddress />
            <ModalDeliverySelector />
            <ModalProductInCart />
            <ModalAddToList />
            <CreateNewList />
            <ProductPreview />
            <ModalConfirmation />
            <ModalLostProducts />
            <ModalPersistsAddress/>
            <NotificationContent />
            <ModalProductsCart/>
            <BannerHour />
            <ModalUserInfo />
            <ModalNewFeature />
            <ModalReschedule />
            <ModalConfirmReschedule />
            <ModalDateDelivery/>
            <ModalOrderCancelSuccess />
            <ModalTermsConditions />
            <ModalAddNotes />
            <ModalNewsletter />
            <MessageInfo />
            <DrawerSimilarProducts />
            <DrawerMiniCart />
            <DrawerAddBankAccount />
            <DrawerQuickPurchase />
            <DrawerReviews />
            <ModalTrackingOrder />
            <DrawerWelcomePrime />
            <DrawerRegisterPrime />
            <DrawerPrimeInvitation />
            <DrawerPaymentMethodPrime />
            <DrawerClientUpdate />
            <DrawerAddToList />
            <DrawerScheduledList/>
            <ModalOrderSuspension />
            <DrawerPaymentMethod />
            <ModalPersistentCart />
            <DrawerAddressSelection />
        </div>
    )
    
}
export default GeneralContent;
